import styles from './SaveSearchWrapper.less';

import React, { Component } from 'react';
import SaveSearch from './SaveSearch';

class SaveSearchWrapper extends Component {
  render() {
    return (
      <section className={styles.root} data-automation="savePanel">
        <h1 className={styles.savePrompt}>Like this search?</h1>
        <p className={styles.saveDescription}>Get new jobs for this search sent to your inbox.</p>
        <SaveSearch />
      </section>
    );
  }
}

export default SaveSearchWrapper;




/** WEBPACK FOOTER **
 ** ./app/components/SearchResultPage/components/SavePanel/components/SaveSearch/SaveSearchWrapper.js
 **/